import React from "react"
import logoUrl from "../../../assets/img/payment-icons/mastercard.svg"

export default function MastercardLogo({ sx }: { sx: React.CSSProperties }) {
    return (
        <img
            src={logoUrl} loading="lazy"
            alt="Mastercard logo"
            style={sx}
        />
    )
}
